"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatingSeason = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var MatingSeason = (function (_super) {
    __extends(MatingSeason, _super);
    function MatingSeason() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.MATING_SEASON,
            cost: 5,
            tags: [Tags_1.Tags.ANIMAL],
            metadata: {
                cardNumber: 'L306',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action(undefined, function (eb) {
                        eb.text('2').animals(1).startAction.text('+1').animals(1);
                    }).br;
                }),
                description: 'Add an animal to each of your cards with at least two animals on it.',
            },
        }) || this;
    }
    MatingSeason.prototype.play = function (player) {
        player.getCardsWithResources().forEach(function (card) {
            if (card.tags.filter(function (tag) { return tag === Tags_1.Tags.ANIMAL; }).length === 0 || card.resourceCount === undefined)
                return undefined;
            if (card.resourceCount >= 2)
                player.addResourceTo(card);
            return undefined;
        });
        return undefined;
    };
    return MatingSeason;
}(Card_1.Card));
exports.MatingSeason = MatingSeason;
//# sourceMappingURL=MatingSeason.js.map